import { ConfirmationData, Question } from "../../../../common/summary-common/confirmationData";

export const updateMapWithFieldsPreserveAll = (updateFields: Array<[string, Question]>, cd: Map<string, ConfirmationData>, setLastBorder: boolean = false): Map<string, ConfirmationData> => {
    const newMap = new Map(cd);
    const lastValidKey = updateFields
        .slice(-1)[0]?.[0];

    updateFields.forEach(([key, question]) => {
        const item = newMap.get(key);
        if (item) {
            // Preservar todas las propiedades originales y sólo actualizar value, hidden y showBorder
            newMap.set(key, {
                ...item,
                value: question.value,
                showBorder: key === lastValidKey ? false : item.showBorder,
                hidden: question.hidden,
                label: question.label
            });
        }
    });

    const lastKey = Array.from(newMap.keys()).pop();
    if (lastKey) {
        const lastItem = newMap.get(lastKey);
        if (lastItem) {
            newMap.set(lastKey, {
                ...lastItem,
                showBorder: setLastBorder,
                label: lastItem.label
            });
        }
    }
    return newMap;
}; 